'use client';

import { useEffect } from 'react';
import * as Swetrix from 'swetrix';

export default function Analytics() {
  useEffect(() => {
    // Explicitly prevent tracking on localhost / development environments
    const isLocalhost =
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1' ||
        window.location.hostname.endsWith('.localhost'));

    const isDev = process.env.NODE_ENV === 'development' || isLocalhost;

    if (isDev) {
      return;
    }

    Swetrix.init('yWJdZQCb2jIN', {
      apiURL: 'https://analytics.piyushchandwani.com/backend/v1/log',
      devMode: false,
      disabled: isDev,
    });

    Swetrix.trackViews();
  }, []);

  return (
    <noscript>
      <img
        src="https://analytics.piyushchandwani.com/backend/log/noscript?pid=yWJdZQCb2jIN"
        alt=""
        referrerPolicy="no-referrer-when-downgrade"
      />
    </noscript>
  );
}
